import { css, cva } from '@/styled-system/css';

export const menuContentRecipe = cva({
  base: {
    borderRadius: 'Menu.Content',
    backgroundColor: 'Menu.Content.bg',
    boxShadow: 'Menu.Content',
    position: 'relative',
    overflow: 'hidden',
    minWidth: 'Menu.Content.width.min',
    maxWidth: 'Menu.Content.width.max',
  },
  variants: {
    dividers: {
      true: {
        '& [data-c11n-component="Menu.Group"]:not(:last-child)': {
          borderBottomWidth: 'Menu.Group',
          borderBottomStyle: 'solid',
          borderBottomColor: 'Menu.Group.border',
        },
      },
      false: {},
    },
  },
});

export const menuContentPositionerStyles = css.raw({
  zIndex: 'menu',
});
